// extracted by mini-css-extract-plugin
export default {"logo":"FunnelControls-logo_yVsvl","logoContainer":"FunnelControls-logoContainer_K3KGD"};